import React from 'react';

import IconToastSuccess from '../Icons/IconToastSuccess';
import IconToastError from '../Icons/IconToastError';

import styles from './style.scss';

import { ToastProps } from '@shopee-user/business-customization-types';

const ICON_MAPPING = {
  success: IconToastSuccess,
  warning: IconToastError,
};

export default function Toast({ text, level }: ToastProps) {
  const Icon = ICON_MAPPING[level];
  return (
    <div className={styles.toastBox}>
      <Icon className={styles.icon} />
      <p className={styles.text}>{text}</p>
    </div>
  );
}
